export default "__VITE_ASSET__sy0F06j0__"